import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.396 8.25a4.5 4.5 0 117.598-1.5",
    opacity: ".2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 00-3 0m0 2.25V9.75a1.5 1.5 0 00-3 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 013 0v2a6.73 6.73 0 01-1.977 4.773A6.73 6.73 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M6.396 8.25a4.5 4.5 0 117.598-1.5",
    opacity: ".2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13.5v-2.25a1.5 1.5 0 00-3 0m0 2.25V9.75a1.5 1.5 0 00-3 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M17.25 13a1.5 1.5 0 013 0v2a6.73 6.73 0 01-1.977 4.773A6.73 6.73 0 0113.5 21.75a6.732 6.732 0 01-4.773-1.977l-6.059-6.059a1.501 1.501 0 012.122-2.121l2.18 2.18a.75.75 0 001.28-.531V5.25a1.5 1.5 0 113 0v8.25"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M12.792 16.5a9 9 0 1115.196-3",
    opacity: ".2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 27v-4.5a3.001 3.001 0 00-6 0m0 4.5v-7.5a3.001 3.001 0 00-6 0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M34.5 26a3.001 3.001 0 016 0v4a13.46 13.46 0 01-3.954 9.546A13.46 13.46 0 0127 43.5a13.464 13.464 0 01-9.546-3.954L5.336 27.428a3 3 0 014.244-4.242l4.36 4.36c.944.944 2.56.276 2.56-1.062V10.5a3 3 0 116 0V27"
  }))
};
export var GestureTap = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});